import { SEARCH_LOCATIONS } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case SEARCH_LOCATIONS:
      return action.payload;
    default:
      return state;
  }
};
